import {usePermissions} from "../../context/AuthzProvider";
import {useOrgSettings} from "../../context/OrgSettingsProvider";
import {filter} from "underscore";

export const usePowerbarItems = () => {
  const {
    canAccessExercise,
    canAccessIncident,
    canAccessExerciseOrIncident,
    canAccessMessage,
    canManageDataOption,
    canManageDataset,
    canManageObligation,
    canManagePermission,
    canManageRole,
    canManageTask,
    canManageUser,
  } = usePermissions();
  const {responseWorkflowName} = useOrgSettings();

  return filter(
    [
      {
        action: "Add Procedure",
        key: "ctrl+alt+o",
        path: "/procedures/add",
        hide: !canManageObligation,
      },
      {
        action: "Add Task to Library",
        key: "ctrl+alt+t",
        path: "/tasks/add",
        hide: !canManageTask,
      },
      {
        action: "Complete My Actions",
        key: "ctrl+alt+a",
        path: "/actions/list",
        hide: !canAccessExerciseOrIncident,
      },
      {
        action: "Create Dataset",
        key: "ctrl+alt+d",
        path: "/datasets/add",
        hide: !canManageDataset,
      },
      {
        action: "Create Exercise",
        key: "ctrl+alt+e",
        path: "/exercises/add",
        hide: !canAccessExercise,
      },
      {
        action: `Create ${responseWorkflowName.upper}`,
        key: "ctrl+alt+i",
        path: `/${responseWorkflowName.lower + "s"}/add`,
        hide: !canAccessIncident,
      },
      {
        action: "Invite New User",
        key: "ctrl+alt+n",
        path: "/users/add",
        hide: !canManageUser,
      },
      {
        action: "Manage Permissions",
        key: "ctrl+alt+g",
        path: "/permissions",
        hide: !canManagePermission,
      },
      {action: "Manage Your Profile", key: "ctrl+alt+y", path: "/userProfile"},
      {
        action: "Send Mail",
        key: "ctrl+alt+m",
        path: "/messaging/new",
        hide: !canAccessMessage,
      },
      {
        action: "View Data Schema",
        key: "ctrl+alt+s",
        path: "/dataOptions/list",
        hide: !canManageDataOption,
      },
      {
        action: "View Roles",
        key: "ctrl+alt+r",
        path: "/roles",
        hide: !canManageRole,
      },
      {
        action: "View Users",
        key: "ctrl+alt+u",
        path: "/users/list",
        hide: !canManageUser,
      },
    ],
    (pbi) => !pbi.hide,
  );
};
